import { initShow } from '~/milestones';
import InitMoreActionsDropdown from '~/milestones/init_more_actions_dropdown';

initShow();
InitMoreActionsDropdown();
